export const APPLE_PAY_GET_SESSION = 'APPLE_PAY_GET_SESSION';
export const APPLE_PAY_GET_SESSION__SUCCESS = 'APPLE_PAY_GET_SESSION__SUCCESS';
export const APPLE_PAY_GET_SESSION__FAILURE = 'APPLE_PAY_GET_SESSION__FAILURE';
export const APPLE_PAY_GET_SESSION__RESET = 'APPLE_PAY_GET_SESSION__RESET';

export const APPLE_PAY_VALIDATE_MERCHANT = 'APPLE_PAY_VALIDATE_MERCHANT';
export const APPLE_PAY_VALIDATE_MERCHANT__SUCCESS = 'APPLE_PAY_VALIDATE_MERCHANT__SUCCESS';
export const APPLE_PAY_VALIDATE_MERCHANT__FAILURE = 'APPLE_PAY_VALIDATE_MERCHANT__FAILURE';
export const APPLE_PAY_VALIDATE_MERCHANT__RESET = 'APPLE_PAY_VALIDATE_MERCHANT__RESET';

export const APPLE_PAY_PAYMENT_AUTHORIZED = 'APPLE_PAY_PAYMENT_AUTHORIZED';
export const APPLE_PAY_PAYMENT_AUTHORIZED__SUCCESS = 'APPLE_PAY_PAYMENT_AUTHORIZED__SUCCESS';
export const APPLE_PAY_PAYMENT_AUTHORIZED__FAILURE = 'APPLE_PAY_PAYMENT_AUTHORIZED__FAILURE';
export const APPLE_PAY_PAYMENT_AUTHORIZED__RESET = 'APPLE_PAY_PAYMENT_AUTHORIZED__RESET';

export const APPLE_PAY__RESET = 'APPLE_PAY__RESET';
